import { render, staticRenderFns } from "./controlType.vue?vue&type=template&id=bddb9cde&scoped=true&"
import script from "./controlType.vue?vue&type=script&lang=js&"
export * from "./controlType.vue?vue&type=script&lang=js&"
import style0 from "./controlType.vue?vue&type=style&index=0&id=bddb9cde&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddb9cde",
  null
  
)

export default component.exports